




















import { SfButton, SfLoader } from '@storefront-ui/vue';
import { defineComponent, PropType } from '@nuxtjs/composition-api';
import type { Product } from '~/modules/catalog/product/types';
import type { Pagination } from '~/composables/types';
import { useUiHelpers } from '~/composables';

export default defineComponent({
  components: {
    SfButton,
    SfLoader,
  },
  props: {
    pagination: {
      type: Object as PropType<Pagination>,
      default: (): Pagination => ({}),
    },
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const uiHelpers = useUiHelpers();

    const showMore = async () => {
      if (props.pagination.currentPage >= props.pagination.totalPages) return;
      await uiHelpers.changePage(props.pagination.currentPage + 1, false);
      emit('submit');
    };

    return {
      showMore,
    };
  },
});
